export const aroundMeModeSelector = ({aroundMeMode}) => aroundMeMode